import { render } from "./AppLayoutAuth.vue?vue&type=template&id=dd4ee034&ts=true"
import script from "./AppLayoutAuth.vue?vue&type=script&lang=ts"
export * from "./AppLayoutAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__